"use client";

import { useI18n } from "@/i18n/client";
import clsx from "clsx";
import { isValidJSON } from "@/utils/is-valid-json";
import { useProductContext } from "@/providers/ProductContextProvider";
import * as Accordion from "@radix-ui/react-accordion";
import IconArrow from "@/components/UI/Icon/IconArrow/IconArrow";
import Markdown from "@/components/UI/Markdown/Markdown";
import Tick from "@/app/assets/images/svg/check.svg";
import accordionStyles from "../ProductPageAccordian.module.scss";
import styles from "./Overview.module.scss";

interface OverviewProps {
	isInAccordion: boolean;
}

const Overview: React.FC<OverviewProps> = ({ isInAccordion }) => {
	const { product } = useProductContext();
	const t = useI18n();
	const USPS = isValidJSON(product.warranty).usp;

	if (!USPS) return <></>;

	const content = (
		<div
			className={clsx([accordionStyles.widthContainer, accordionStyles.column])}
		>
			<Markdown
				content={product.description}
				className={styles.overviewContent}
			/>
			<div className={styles.list}>
				{USPS.map((usp: string, index: number) => (
					<div className={styles.item} key={`${index}-${usp}`}>
						<div className={styles.checkMark}>
							<Tick />
						</div>
						{usp}
					</div>
				))}
			</div>
		</div>
	);

	return isInAccordion ? (
		<Accordion.Item value='Overview'>
			<Accordion.Header>
				<Accordion.Trigger className={accordionStyles.header} id='Overview'>
					<div className={accordionStyles.widthContainer}>
						{t("product.overview")}
						<IconArrow
							direction='down'
							aria-labelledby='directional chevron pointing down'
						/>
					</div>
				</Accordion.Trigger>
			</Accordion.Header>
			<Accordion.Content className={accordionStyles.content}>
				{content}
			</Accordion.Content>
		</Accordion.Item>
	) : (
		content
	);
};

export default Overview;
